import { IDonorConnectIncidentLog } from '@nkr/models/donor-connect-incident-log';

export interface IIncidentReportAddEdit {
    id: number,
    centerId: number,
    candidateFirstName: string,
    candidateLastName: string,
    centerDisplayUserId: number,
    donorConnectGroup: number,
    incidentDate: string,
    incidentOriginTypeId: number,    
    incidentCategoryTypeId: number,
    incidentStatusId: number,
    assignedMentorId: number,
    description: string,
    logs: IDonorConnectIncidentLog[],
}
